import React from "react";
import { Header } from "../components/header";
import { Features } from "../components/features";
import { About } from "../components/about";
import { Stats } from "../components/stats";
import { Materials } from "../components/materials";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
import { Markets } from "../components/markets";
import { Cta } from "../components/cta";

const Home = ({ data }) => (
  <>
    <Header data={data.Header} />
    <Features data={data.Features} />
    <About data={data.About} />
    <Stats data={data.Stats} />
    <Materials data={data.Materials} />
    <Services data={data.Services} />
    <Gallery data={data.Gallery} />
    <Markets data={data.Markets} />
    <Cta
      title="Tell us what you need cut"
      text="Blocks off the bench, bundled slabs, or finished stone to a drawing — send us the specification and we will come back with samples, a price and a loading date."
      buttonLabel="Start an Enquiry"
    />
  </>
);

export default Home;
